import { render, staticRenderFns } from "./AdminPage2Skeleton.vue?vue&type=template&id=c8da9906&scoped=true"
import script from "./AdminPage2Skeleton.vue?vue&type=script&lang=js"
export * from "./AdminPage2Skeleton.vue?vue&type=script&lang=js"
import style0 from "./AdminPage2Skeleton.vue?vue&type=style&index=0&id=c8da9906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8da9906",
  null
  
)

export default component.exports